<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-车位-修改
    -->
    <el-dialog
    title="修改车位"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">修改车位</div>

      <el-form-item label="车位编号" prop="parking_number">
        <el-input v-model="form.parking_number" placeholder="请输入车位编号" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="车位名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入车位名称" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="车位价格" prop="price">
        <el-input v-model="form.price" placeholder="请输入车位价格" class="max-w200">
          <template slot="append">元/月</template>
        </el-input>
      </el-form-item>

      <el-form-item label="排序" prop="sort">
        <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
      </el-form-item>
       
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</el-dialog>
</template>

<script>
import Parking_spaceApi from '@/api/parking_space.js';
import SupplyApi from '@/api/supply.js'; // 引入物业API
import Uediter from '@/components/UE.vue';
import Staff from '@/components/user/Staff.vue';

export default {
  components: {
     Uediter,
     Staff
  },
  data() {
    // 价格验证规则
    const validatePrice = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入车位价格'));
      } else if (isNaN(value)) {
        callback(new Error('请输入有效的数字'));
      } else if (value < 0) {
        callback(new Error('价格不能为负数'));
      } else {
        callback();
      }
    };
    
    return {
      /*富文本配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 300
        }
      },
      /*form表单数据*/
      form: {
        parking_number: '', // 车位编号
        name: '', // 车位名称
        price: '', // 车位价格
        supply_id: '', // 所属物业ID
        status: 2, // 1:已租, 2:空置
        staff_id: 0,
        sort: 50,
        intro: ""
      },
      // 物业列表
      supplyList: [],
      loading: false,
      /*验证规则*/
      rules: {
        parking_number: [{ required: true, message: '请输入车位编号', trigger: 'blur' }],
        name: [{ required: true, message: '请输入车位名称', trigger: 'blur' }],
        price: [{ required: true, validator: validatePrice, trigger: 'blur' }],
        supply_id: [{ required: true, message: '请选择所属物业', trigger: 'change' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      },
      dialogVisible: false,
      // 选择用户开关
      isOpenStaff: false,
      staff: {}
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.getSupplyList(); // 获取物业列表
    this.getDetail();
  },
  props: ["open_add","parking_space_id"],
  methods: {
    /*获取物业列表*/
    getSupplyList() {
      let self = this;
      SupplyApi.supplyList({}, true)
        .then(data => {
          self.supplyList = data.data.list.data || [];
        })
        .catch(error => {
          console.error('获取物业列表失败:', error);
        });
    },
    
    /*打开获取用户*/
    openStaff() {
      this.isOpenStaff = true;
    },
    
    /*关闭获取用户*/
    closeStaffFunc(e) {
      if (e.type != 'error') {
        this.form.staff_id = e.params.staff_id;
        this.staff = e.params;
      }
      this.isOpenStaff = false;
    },

    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", {});
    },
    
    cancelFunc() {
      this.dialogFormVisible("error");
    },
    
    getDetail() {
      let self = this;
      Parking_spaceApi.detail({parking_space_id: self.parking_space_id}, true).then(res => {
          self.form = res.data;
          self.loading = false;
          
          // 如果已有管家信息，初始化管家显示
          if (self.form.staff_id && self.form.staff_name) {
            self.staff = {
              staff_id: self.form.staff_id,
              name: self.form.staff_name,
              image_url: self.form.staff_image || ''
            };
          }
        })
        .catch(error => {});
    },
    
    onSubmit() {
      let self = this;
      let form = self.form;
      
      form.parking_space_id = self.parking_space_id;
      
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Parking_spaceApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error");
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 300px;
}

.select-user {
  margin-top: 10px;
}

.select-user li {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 5px 10px;
  background-color: #f5f7fa;
}

.max-w200 {
  max-width: 200px;
}

.max-w460 {
  max-width: 460px;
}

.el-form-item {
  margin-bottom: 15px;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/parking_space/index/part/edit.vue